import React, { useState, useEffect } from "react";

function PsikologCard({ psikolog, onBook, onViewProfile, selectedDate }) {
  const [scheduleDays, setScheduleDays] = useState([]);

  useEffect(() => {
    if (psikolog.available_dates) {
      // Mengambil 4 jadwal pertama untuk ditampilkan di card
      setScheduleDays(psikolog.available_dates.slice(0, 4));
    }
  }, [psikolog]);

  /**
   * Fungsi untuk mengecek apakah tanggal pada item jadwal
   * sama dengan tanggal yang sedang dipilih di filter.
   */
  const isDateActive = (itemDate) => {
    if (!selectedDate || !itemDate) return false;

    // Asumsi selectedDate formatnya "YYYY-MM-DD"
    // Dan item.date formatnya juga "YYYY-MM-DD"
    return itemDate === selectedDate;
  };

  return (
    <div className="col-12 col-md-6 col-lg-4">
      <div className="card-psikolog rounded-xl shadow-sm h-100">
        <div className="d-flex flex-row flex-md-row gap-3 p-4 text-left text-md-start align-items-center align-items-md-start">
          <img
            src={psikolog.foto}
            className="rounded-circle"
            width="72"
            height="72"
            alt={psikolog.name}
            style={{ objectFit: "cover" }}
          />
          <div>
            <div
              className="fw-semibold text-decoration-underline"
              style={{ cursor: "pointer" }}
              onClick={onViewProfile}
            >
              {psikolog.name}
            </div>
            <div className="small text-muted">{psikolog.bahasa}</div>
          </div>
        </div>

        <div className="border-top p-1">
          <div className="d-flex flex-column flex-md-row justify-content-center align-items-center gap-3 mb-3 mt-3">
            <button onClick={onBook} className="btn btn-brand w-50 w-md-auto">
              <i className="bi bi-calendar-plus me-2"></i> Buat Janji
            </button>
          </div>

          <div className="schedule-card">
            {scheduleDays.map((item, index) => {
              // Cek apakah tanggal ini aktif
              const active = isDateActive(item.date);

              return (
                <div
                  key={index}
                  className={`schedule-item ${active ? "active" : ""}`}
                >
                  {/* Bar hijau/biru di atas jika aktif */}
                  <div className={` ${active ? "schedule-bar" : ""}`}></div>
                  <div className="schedule-day">{item.day}</div>
                  <div className="schedule-time">
                    {item.slot?.label || "Tidak Tersedia"}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PsikologCard;
